export default __webpack_public_path__ + "static/media/email-check.8e045597.svg";